import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Link from '@material-ui/core/Link';
import {useHistory} from 'react-router-dom';

export default function Subscription__Cancel (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.root}>
            Oops ! Something gone wrong, please 
            <Link style={{padding: '0 2px'}} onClick={() => history.push('/Subscription')}>
                 try again 
            </Link> 
            or contact support.
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    }
});